export default {
    INITIALIZED: 'INITIALIZED',
    RESET: 'RESET',
    PRELOADED: 'PRELOADED',
    REQUEST_PENDING: 'REQUEST_PENDING',
    REQUEST_SUCCESS: 'REQUEST_SUCCESS',
    REQUEST_ERROR: 'REQUEST_ERROR'
}